import { getCsrfToken, instance, csrfToken } from '../db';
import { ProductContactType } from '../../validation/contact/contactType';
import { contactKind } from '../../constants/Enum';

// 建材登録の問い合わせ送信API
export const sendProductContact = async (
  userId: string,
  watch: (fieldName: string) => ProductContactType
): Promise<void> => {
  await getCsrfToken();

  await instance.post(
    '/contacts/',
    {
      kind: contactKind.building,
      user_id: userId,
      company: watch('company'),
      department: watch('department'),
      name: watch('name'),
      email: watch('email'),
      tel: watch('tel'),
      content: watch('content'),
      type: 5
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
};
